const DEFAULT_STATE = {
  sidebar: {
    touched: false, // Whether use has changed default expanded mode
    expanded: true
  }
};

export default (state = DEFAULT_STATE, action) => {
  return state;
}